import React from 'react';
import Helmet from 'react-helmet';
import { StaticQuery, graphql } from 'gatsby';
import '../styles/_.styl';
import '../styles/global.css';

import Nav from '../components/GlobalNav';
import Footer from '../components/Footer';
import { ensureTrailingSlash } from '../utils/ensureTrailingSlash';

import Disclaimer from '../components/Disclaimer';

export function Canonical({ location }) {
  if (!location) return null;
  return (
    <Helmet>
      <link
        rel="canonical"
        href={`https://paperform.co${ensureTrailingSlash(location.pathname)}`}
      />
    </Helmet>
  );
}

export default function Index({
  children,
  noNav,
  fixedNav,
  noFooter,
  invertNav,
  noFade,
  noMeta,
  location,
  wrapperClass,
  isTry,
  disclaimer,
}) {
  return (
    <StaticQuery
      query={graphql`
        query LayoutQuery {
          site {
            siteMetadata {
              title
            }
          }
        }
      `}
      render={(data) => (
        <>
          <Canonical location={location} />

          {!noMeta ? (
            <Helmet
              titleTemplate={`%s | ${data.site.siteMetadata.title}`}
              defaultTitle={data.site.siteMetadata.title}
            >
              <meta
                name="description"
                content="Try for free - No CC required! Paperform enables anyone create beautiful online forms, payment or product pages, quickly and intuitively, without any technical knowledge."
              />
              <meta property="og:site_name" content="Paperform" />
              <meta property="og:type" content="website" />
              <meta
                property="og:image"
                content="https://paperform.co/images/meta.png"
              />
              <meta property="og:image:width" content="1398" />
              <meta property="og:image:height" content="846" />

              <meta property="twitter:site" content="@PaperformCo" />
              <meta name="twitter:card" content="summary_large_image" />
              <meta
                property="twitter:image"
                content="https://paperform.co/images/meta.png"
              />
              <meta property="twitter:image:width" content="1398" />
              <meta property="twitter:image:height" content="846" />
              {location ? (
                <meta
                  property="og:url"
                  content={`https://paperform.co${ensureTrailingSlash(
                    location.pathname,
                  )}`}
                />
              ) : null}
              <meta
                property="og:description"
                content="Paperform is a web platform that enables anyone to create beautiful online forms, payment or product pages, quickly and intuitively, without any technical knowledge."
              />
            </Helmet>
          ) : null}
          <div className={wrapperClass}>
            {noNav ? null : (
              <Nav
                fixed={!!fixedNav}
                invert={!!invertNav}
                noFade={noFade}
                isTry={isTry}
                location={location}
              />
            )}
            {children}
            {noFooter ? null : <Footer />}
            {disclaimer ? <Disclaimer content={disclaimer} /> : null}
          </div>
        </>
      )}
    />
  );
}
